import { use } from 'react';

import { MainSidebarContext } from '@/contexts/MainSidebarContext';

export function useMainSidebar() {
  const context = use(MainSidebarContext);
  if (!context) {
    throw new Error('useMainSidebar must be used within MainSidebarProvider');
  }
  return context;
}
